import gsap from 'gsap';

export function initCarousel() {
  const root = document.querySelector('[data-carousel]');
  if (!root) return;

  const track = root.querySelector('.carousel__track');
  const slides = [...root.querySelectorAll('.carousel__slide')];
  const prev = root.querySelector('[data-carousel-prev]');
  const next = root.querySelector('[data-carousel-next]');
  if (!track || slides.length === 0) return;

  let index = 0;
  let animating = false;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const markActive = () => {
    slides.forEach((slide, i) => {
      const active = i === index;
      slide.classList.toggle('is-side', !active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
  };

  const go = (nextIndex, instant = false) => {
    index = (nextIndex + slides.length) % slides.length;
    markActive();
    const duration = instant || reducedMotion.matches ? 0 : 0.7;
    animating = duration > 0;
    gsap.to(track, {
      scrollLeft: slides[index].offsetLeft,
      duration,
      ease: 'power3.out',
      overwrite: true,
      onComplete: () => {
        animating = false;
      },
    });
  };

  prev?.addEventListener('click', () => go(index - 1));
  next?.addEventListener('click', () => go(index + 1));

  root.setAttribute('tabindex', '0');
  root.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      go(index - 1);
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      go(index + 1);
    }
  });

  const syncFromScroll = () => {
    if (animating) return;
    const nearest = slides.reduce(
      (best, slide, i) => {
        const distance = Math.abs(slide.offsetLeft - track.scrollLeft);
        return distance < best.distance ? { i, distance } : best;
      },
      { i: index, distance: Number.POSITIVE_INFINITY }
    );
    if (nearest.i !== index) {
      index = nearest.i;
      markActive();
    }
  };

  let scrollTick = 0;
  track.addEventListener(
    'scroll',
    () => {
      window.clearTimeout(scrollTick);
      scrollTick = window.setTimeout(syncFromScroll, 80);
    },
    { passive: true }
  );

  let resizeTick = 0;
  const realign = () => {
    window.clearTimeout(resizeTick);
    resizeTick = window.setTimeout(() => go(index, true), 50);
  };
  window.addEventListener('resize', realign);
  if (typeof ResizeObserver === 'function') {
    new ResizeObserver(realign).observe(root);
  }

  go(0, true);
}
